import Layout from '@glu/layout-react';
import { withTheme } from '@glu/theming';
import { FormSection } from '@glu/validation-react';
import PropTypes from 'prop-types';
import React from 'react';
import Fieldset from '../utility/Fieldset';
import ColorInput from '../components/Color/Color';
import StyleInput from '../components/StyleInput/StyleInput';

const ButtonForm = ({ theme: { buttons, palette: { background } } }) => {
  const { primary, secondary, tertiary } = buttons;

  return (
    <FormSection name="buttons">
      <Layout container>
        <FormSection name="primary">
          <Layout col={4}>
            <Fieldset legend="Primary">
              <ColorInput
                name="backgroundColor"
                labelText="Background Color"
              />

              <ColorInput
                name="focusColor"
                labelText="Focus Color"
                backgroundColor={primary.focusColor}
                fontSize={buttons.fontSize}
                fontWeight={primary.fontWeight}
              />

              <ColorInput
                name="hoverColor"
                labelText="Hover Color"
                backgroundColor={primary.hoverColor}
                fontSize={buttons.fontSize}
                fontWeight={primary.fontWeight}
              />

              <ColorInput
                name="textColor"
                labelText="Text Color"
                backgroundColor={primary.backgroundColor}
                fontSize={buttons.fontSize}
                fontWeight={primary.fontWeight}
              />
            </Fieldset>
          </Layout>
        </FormSection>

        <FormSection name="secondary">
          <Layout col={4}>
            <Fieldset legend="Secondary">
              <ColorInput
                name="backgroundColor"
                labelText="Background Color"
                fontSize={buttons.fontSize}
                fontWeight={secondary.fontWeight}
              />

              <ColorInput
                name="borderColor"
                labelText="Border Color"
                fontSize={buttons.fontSize}
                fontWeight={secondary.fontWeight}
              />

              <ColorInput
                name="focusColor"
                labelText="Focus Color"
                backgroundColor={secondary.focusColor}
                fontSize={buttons.fontSize}
                fontWeight={secondary.fontWeight}
              />

              <ColorInput
                name="focusBorderColor"
                labelText="Focus Border Color"
                fontSize={buttons.fontSize}
                fontWeight={secondary.fontWeight}
              />

              <ColorInput
                name="hoverColor"
                labelText="Hover Color"
                backgroundColor={secondary.hoverColor}
                fontSize={buttons.fontSize}
                fontWeight={secondary.fontWeight}
              />

              <ColorInput
                name="textColor"
                labelText="Text Color"
                backgroundColor={secondary.backgroundColor}
                fontSize={buttons.fontSize}
                fontWeight={secondary.fontWeight}
              />
            </Fieldset>
          </Layout>
        </FormSection>

        <FormSection name="tertiary">
          <Layout col={4}>
            <Fieldset legend="Tertiary">
              <ColorInput
                name="textColor"
                labelText="Text Color"
                backgroundColor={background}
                fontSize={buttons.fontSize}
                fontWeight={tertiary.fontWeight}
              />

              <StyleInput
                name="textDecoration"
                labelText="Text Decoration"
                displayText="Aa"
                color={tertiary.textColor}
                backgroundColor={background}
                fontSize={buttons.fontSize}
                fontWeight={tertiary.fontWeight}
                textDecoration={tertiary.textDecoration}
                borderColor="inherit"
              />

              <StyleInput
                name="focusTextDecoration"
                labelText="Focus Text Decoration"
                displayText="Aa"
                color={tertiary.textColor}
                backgroundColor={background}
                fontSize={buttons.fontSize}
                fontWeight={tertiary.fontWeight}
                textDecoration={tertiary.focusTextDecoration}
                borderColor="inherit"
              />

              <StyleInput
                name="hoverTextDecoration"
                labelText="Hover Text Decoration"
                displayText="Aa"
                color={tertiary.textColor}
                backgroundColor={background}
                fontSize={buttons.fontSize}
                fontWeight={tertiary.fontWeight}
                textDecoration={tertiary.hoverTextDecoration}
                borderColor="inherit"
              />
            </Fieldset>
          </Layout>
        </FormSection>
      </Layout>
    </FormSection>
  );
};
ButtonForm.propTypes = {
  theme: PropTypes.shape({
    palette: PropTypes.shape({
      background: PropTypes.string
    }),
    buttons: PropTypes.shape({
      fontSize: PropTypes.number,
      borderRadius: PropTypes.number,
      primary: PropTypes.objectOf(
        PropTypes.oneOfType([PropTypes.string, PropTypes.number])
      ).isRequired,
      secondary: PropTypes.objectOf(
        PropTypes.oneOfType([PropTypes.string, PropTypes.number])
      ).isRequired,
      tertiary: PropTypes.objectOf(
        PropTypes.oneOfType([PropTypes.string, PropTypes.number])
      ).isRequired
    }).isRequired
  }).isRequired
};

export default withTheme(ButtonForm);
